export type ThemeMode = 'light' | 'dark' | 'system'
export type ResolvedTheme = 'light' | 'dark' | 'amoled'
export const THEME_STORAGE_KEY = 'scpTheme'
export const AMOLED_STORAGE_KEY = 'scpAmoled'
type Store = { getItem(key: string): string | null; setItem(key: string, value: string): void }

export function readThemePreference(storage: Pick<Store, 'getItem'>): { mode: ThemeMode; amoled: boolean } {
  try {
    const raw = storage.getItem(THEME_STORAGE_KEY)
    return {
      mode: raw === 'amoled' ? 'dark' : raw === 'light' || raw === 'dark' ? raw : 'system',
      amoled: raw === 'amoled' || storage.getItem(AMOLED_STORAGE_KEY) === '1',
    }
  } catch { return { mode: 'system', amoled: false } }
}

export function persistThemePreference(storage: Store, mode: ThemeMode, amoled: boolean): void {
  try {
    storage.setItem(THEME_STORAGE_KEY, mode)
    storage.setItem(AMOLED_STORAGE_KEY, amoled ? '1' : '0')
  } catch { /* React state still applies for this visit. */ }
}

export function resolveThemePreference(mode: ThemeMode, amoled: boolean, systemDark: boolean): ResolvedTheme {
  const base = mode === 'system' ? (systemDark ? 'dark' : 'light') : mode
  return base === 'dark' && amoled ? 'amoled' : base
}
